import { useEffect, useState } from 'react';
import { Template } from "../../Components/Template/template";
import Chart from 'react-google-charts';
import { useDispatch } from 'react-redux';
import { changeHash, changeName, selectUser } from '../../Components/Redux/userSlice';
import { GiCardPlay, GiPayMoney, GiPodium, GiReceiveMoney } from "react-icons/gi";
import { useSelector } from 'react-redux';
import { IoTicketSharp } from 'react-icons/io5';
import { BsFillCartCheckFill } from 'react-icons/bs';
import { Cartao, CtaPagar, CtaReceber, DadosEstoque, DadosSaldoContas, HomeService, ResTop10Produtos, ResVendaFpagto, ResVendaMensal } from './HomeService';
import moment from 'moment';
import { Funcoes } from '../../Utils/Funcoes';
import { v4 as uuid } from 'uuid'
import { classbtColunasAzul } from '../../Utils/Types';
import { TbBoxOff, TbPigMoney } from 'react-icons/tb';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import iconDespesa from '../../assets/imagens/iconDespesas.png'
import iconReceita from '../../assets/imagens/iconReceita.png'
import iconChequeDeposito from '../../assets/imagens/iconChequePDeposito.png'

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'none',
        },
        title: {
            display: true,
            text: 'Chart.js Line Chart',
        },
    },
}

// '#FFD700', '#FFA500', '#FFFFFF', '#DC143C', '#A020F0', '#0000FF', '#F4A460', '#F0F8FF', '#EEE8AA', '#F0FFF0'
const colors = ['#0288D1']

export const HomePage = () => {

    // data de hoje
    let dateIDia = moment().utcOffset('-03:00').format('YYYY-MM-DD')
    let dateFDia = moment().utcOffset('-03:00').format('YYYY-MM-DD')

    // data da semana
    let dateISemana = moment().utcOffset('-03:00').startOf('week').format('YYYY-MM-DD');
    let dateFSemana = moment().utcOffset('-03:00').endOf('week').format('YYYY-MM-DD');

    // data do mes
    let dateIMes = moment().utcOffset('-03:00').startOf('month').format('YYYY-MM-DD');
    let dateFMes = moment().utcOffset('-03:00').endOf('month').format('YYYY-MM-DD');

    const [dataInicio, setDataInicio] = useState(dateIDia)
    const [dataFim, setDataFim] = useState(dateFDia)

    const dispatch = useDispatch()

    let user = useSelector(state => selectUser(state))
    let modeDark = user.modeDark

    //const [showMenuReceita, setShowMenuReceita] = useState(false)
    //const [loadingReceita, setLoadingReceita] = useState(false)
    //const [showMenuDespesa, setshowMenuDespesa] = useState(false)
    //const [showMenuVenda, setshowMenuVenda] = useState(false)
    //const [showMenuTicketMedioCliente, setShowMenuTicketMedioCliente] = useState(false)
    //const [showMenuCheques, setshowMenuCheque] = useState(false)
    //const [showMenuResVendaMensal, setshowMenuResVendaMensal] = useState(false)
    //const [showMenuDocEmitido, setShowMenuDocEmitido] = useState(false)
    //const [showMenuTop10Prods, setshowMenuTop10Prods] = useState(false)
    //const [showMenuVendaFpagto, setshowMenuVendaFpagto] = useState(false)
    //const [showMenuDupPagar, setshowMenuDupPagar] = useState(false)
    //const [showMenuReceber, setshowMenuReceber] = useState(false)
    //const [loadingCtaPagar, setLoadingCtaPagar] = useState(false)

    const [receita, setReceita] = useState(0)
    const [despesa, setDespesa] = useState(0)
    const [venda, setVenda] = useState(0)
    const [ticketMedioVenda, setTicketMedioVenda] = useState(0)
    const [vlCheDeposito, setVlCheDeposito] = useState(0)

    const [resVendaMensal, setResVendaMensal] = useState<any[]>([])
    const [resVendaFpagto, setResVendaFpagto] = useState<any[]>([])
    const [titleFpagto, setTitleFpagto] = useState("Forma de pagamento")

    //const [ticksChartBar, setTicksChartBar] = useState<number[]>([])
    //const [ctaReceberList, setCtaReceberList] = useState<CtaReceber[]>([])

    const [dupReceberList, setDupReceberList] = useState<CtaReceber[]>([])
    const [dupPagarList, setDupPagarList] = useState<CtaPagar[]>([])
    const [lanctoCartaoList, setLanctoCartaoList] = useState<Cartao[]>([])
    const [top10ProdutosList, setTop10ProdutosList] = useState<ResTop10Produtos[]>([])
    const [saldoContasList, setSaldoContasList] = useState<DadosSaldoContas[]>([])
    const [estoqueList, setEstoqueList] = useState<DadosEstoque[]>([])

    const [pagesDupReceber, setPagesDupReceber] = useState<number[]>([])
    const [pagesDupPagar, setPagesDupPagar] = useState<number[]>([])
    const [pagesLanctoCartao, setPagesLanctoCartao] = useState<number[]>([])
    const [pagesSaldoContas, setPagesSaldoContas] = useState<number[]>([])
    const [pagesEstoque, setPagesEstoque] = useState<number[]>([])

    const [currentPageDupReceber, setCurrentPageDupReceber] = useState(1)
    const [currentPageDupPagar, setCurrentPageDupPagar] = useState(1)
    const [currentPageLanctoCartao, setCurrentPageLanctoCartao] = useState(1)
    const [currentPageSaldoContas, setCurrentPageSaldoContas] = useState(1)
    const [currentPageEstoque, setCurrentPageEstoque] = useState(1)

    const [loadingDupReceberList, setLoadingDupReceberList] = useState(false)
    const [loadingDupPagarList, setLoadingDupPagarList] = useState(false)
    const [loadingLanctoCartaoList, setLoadingLanctoCartaoList] = useState(false)
    const [loadingSaldoContasList, setLoadingSaldoContasList] = useState(false)
    const [loadingEstoqueList, setLoadingEstoqueList] = useState(false)

    const [loading, setLoading] = useState(false)
    const [filter_type_dashboard, setFilter_Type_Dashboard] = useState('Dia')

    const optionsChart = {
        tooltip: { isHtml: true },
        titlePosition: 'right',
        title: "",
        titleTextStyle: {
            color: '#fff',
        },

        hAxis: {
            //title: "",
            textStyle: { color: '#fff' },
            titleTextStyle: { color: '#fff' },
            viewWindow: {
                min: 0
            }
        },
        vAxis: {
            format: 'short',
            title: "Em Reais",
            textStyle: { color: '#fff' },
            titleTextStyle: { color: '#fff', fontSize: 14, fontName: 'Roboto', bold: true, italic: false },
            gridlines: {
                color: '#fff',
            },
            viewWindow: {
                min: 0
            }
        },
        series: {
            0: {
                curveType: "function",
                lineWidth: 2,
                pointSize: 5, // Tamanho dos pontos
                pointShape: 'circle', // Forma dos pontos
            },
        },
        chartArea: {
            width: '100%',
            left: '12%',
            right: '5%',
        },
        backgroundColor: '#60A5FA', // cor de fundo
        legend: 'none'
    }

    const optionsBar = {
        tooltip: { isHtml: true },
        titlePosition: 'right',
        title: titleFpagto,
        titleTextStyle: {
            color: '#fff',
        },
        // estilo para os dados na horizontal
        hAxis: {
            textStyle: { color: '#fff' },
            //title: 'Forma de Pagamento',
            titleTextStyle: { color: '#fff', position: 'center', },
        },
        // estilo para os dados na vertical
        vAxis: {
            format: 'short',
            title: "Em Reais",
            textStyle: { color: '#fff' },
            titleTextStyle: { color: '#fff', fontSize: 14, fontName: 'Roboto', bold: true, italic: false },
            gridlines: {
                color: '#4a4845',
            },
            baselineColor: '#4a4845',
            viewWindow: {
                min: 0
            }
        },
        // estilo para as barras
        chartArea: {
            width: '85%',
            left: '12%',
        },
        backgroundColor: '#343439', // cor de fundo
        bar: {
            groupWidth: '30%',
        }, // largura das barras
        legend: 'none'
    }

    useEffect(() => {
        getDataLocalStorage()
        getDadosDashboardDia()
    }, []);

    const getDataLocalStorage = () => {
        let hash = localStorage.getItem('@ecommerce/hash')
        let name = localStorage.getItem('@ecommerce/name')
        dispatch(changeHash(hash))
        dispatch(changeName(name))
    }

    const getDadosDashboardDia = async () => {

        setLoading(true)
        setFilter_Type_Dashboard('Dia')

        try {

            const dadosDashboard = await HomeService.GetData(dateIDia, dateFDia)
            setDataInicio(dateIDia)
            setDataFim(dateFDia)

            setReceita(dadosDashboard.receita)
            setDespesa(dadosDashboard.despesa)
            setVenda(dadosDashboard.venda)
            setTicketMedioVenda(dadosDashboard.ticketMedioVenda)
            setVlCheDeposito(dadosDashboard.valorChequeDeposito)

            let res = []
            res.push(["X", "Vendas", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])

            dadosDashboard.resVendaMensal.map((item: ResVendaMensal) => {
                let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'

                roleTooltip += '<div>'
                roleTooltip += '<strong>' + item.mes + '</strong>'
                roleTooltip += '</div>'
                roleTooltip += '<div style="margin: 5px 0">'
                roleTooltip += 'Venda: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                roleTooltip += '</div>'
                roleTooltip += '</div>'

                res.push([
                    item.mes, item.valor, 'fill-color: #FFF; fill-opacity: 0.1; stroke-color: #FFF; stroke-opacity: 1; stroke-width: 5',
                    roleTooltip
                ]);
                return true
            })

            setResVendaMensal(res)

            let resFpagto = []

            if (dadosDashboard.resVendaFpagto.length > 0) {

                //setTicksChartBar([])
                resFpagto.push(["X", "Forma de Pagamento", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                let position = 0
                dadosDashboard.resVendaFpagto.map((item: ResVendaFpagto) => {
                    let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'
                    roleTooltip += '<div>'
                    roleTooltip += '<strong>' + item.descricao + '</strong>'
                    roleTooltip += '</div>'
                    roleTooltip += '<div style="margin: 5px 0">'
                    roleTooltip += 'Valor: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                    roleTooltip += '</div>'
                    roleTooltip += '</div>'

                    resFpagto.push(
                        [item.descricao, item.valor, `stroke-color: #fff; stroke-opacity: 0.8; stroke-width: 1; fill-color: ${colors[0]}; `, roleTooltip],
                    )
                    if (position > 9) {
                        position = 0
                    } else {
                        position++
                    }

                    return true
                })

            } else {
                setTitleFpagto("")
                resFpagto.push(["X", "", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                resFpagto.push(
                    [
                        "", 0, "stroke-color: #fff; stroke-opacity: 1; stroke-width: 2; fill-color: #fff; fill-opacity: 1", ""
                    ]
                )
                //setTicksChartBar([0, 500, 1000, 1500, 2000, 2500])
            }

            setResVendaFpagto(resFpagto)
            setTop10ProdutosList(dadosDashboard.resTop10Produtos)


            // CONTAS A PAGAR ----------------------------------------------------------------------------------------------
            const dadosCtaPagar = dadosDashboard.ctaPagarList.DadosCtaPagar.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupPagarList(dadosCtaPagar)
            calcQtdPagesDupPagar(dadosDashboard.ctaPagarList.total)
            setCurrentPageDupPagar(1)


            // CONTAS A RECEBER ----------------------------------------------------------------------------------------------
            const dadosCtaReceber = dadosDashboard.ctaReceberList.DadosCtaReceber.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupReceberList(dadosCtaReceber)
            calcQtdPagesDupRec(dadosDashboard.ctaReceberList.total)
            setCurrentPageDupReceber(1)

            // LANÇAMENTO DE CARTAO ----------------------------------------------------------------------------------------------
            const dadosLanctoCartao = dadosDashboard.lanctoCartaoList.DadosLanctoCartao.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.dt_vencimento).getTime();
                const dataB = new Date(b.dt_vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setLanctoCartaoList(dadosLanctoCartao)
            calcQtdPagesLanctoCartao(dadosDashboard.lanctoCartaoList.total)
            setCurrentPageLanctoCartao(1)


            // SALDO DAS CONTAS ----------------------------------------------------------------------------------------------
            const dadosSaldo = dadosDashboard.saldoConta.DadosSaldo.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setSaldoContasList(dadosSaldo)
            calcQtdPagesSaldoContas(dadosDashboard.saldoConta.total)
            setCurrentPageSaldoContas(1)


            // ESTOQUE PRODUTOS ----------------------------------------------------------------------------------------------
            const dadosEstoque = dadosDashboard.produtoEstoque.DadosEstoque.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setEstoqueList(dadosEstoque)
            calcQtdPagesEstoque(dadosDashboard.produtoEstoque.total)
            setCurrentPageEstoque(1)

            /*
            const respSaldo = await HomeService.SaldoContas(currentPageSaldoContas)
            if (respSaldo.DadosSaldo.length > 0) {
                calcQtdPagesSaldoContas(respSaldo.total)
                setSaldoContasList(respSaldo.DadosSaldo)
            }
    
            const respDupRec = await HomeService.RelCtaReceber(dateIDia, dateFDia, currentPageSaldoContas)
            if (respDupRec.DadosCtaReceber.length > 0) {
                calcQtdPagesDupRec(respDupRec.total)
                setDupReceberList(respDupRec.DadosCtaReceber)
            }
    
            const respEstoque = await HomeService.ProdutoReposicao(currentPageEstoque)
            if (respEstoque.DadosEstoque.length > 0) {
                calcQtdPagesEstoque(respEstoque.total)
                setEstoqueList(respEstoque.DadosEstoque)
            }
            */

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)

        }
    }

    const getDadosDashboardSemana = async () => {

        setLoading(true)
        setFilter_Type_Dashboard('Semana')

        try {

            const dadosDashboard = await HomeService.GetData(dateISemana, dateFSemana)

            setDataInicio(dateISemana)
            setDataFim(dateFSemana)

            setReceita(dadosDashboard.receita)
            setDespesa(dadosDashboard.despesa)
            setVenda(dadosDashboard.venda)
            setTicketMedioVenda(dadosDashboard.ticketMedioVenda)
            setVlCheDeposito(dadosDashboard.valorChequeDeposito)

            let res = []
            res.push(["X", "Vendas", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])

            dadosDashboard.resVendaMensal.map((item: ResVendaMensal) => {
                let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'

                roleTooltip += '<div>'
                roleTooltip += '<strong>' + item.mes + '</strong>'
                roleTooltip += '</div>'
                roleTooltip += '<div style="margin: 5px 0">'
                roleTooltip += 'Venda: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                roleTooltip += '</div>'
                roleTooltip += '</div>'

                res.push([
                    item.mes, item.valor, 'fill-color: #FFF; fill-opacity: 0.1; stroke-color: #FFF; stroke-opacity: 1; stroke-width: 5',
                    roleTooltip
                ]);
                return true
            })

            setResVendaMensal(res)

            let resFpagto = []

            if (dadosDashboard.resVendaFpagto.length > 0) {

                //setTicksChartBar([])
                resFpagto.push(["X", "Forma de Pagamento", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                let position = 0
                dadosDashboard.resVendaFpagto.map((item: ResVendaFpagto) => {
                    let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'
                    roleTooltip += '<div>'
                    roleTooltip += '<strong>' + item.descricao + '</strong>'
                    roleTooltip += '</div>'
                    roleTooltip += '<div style="margin: 5px 0">'
                    roleTooltip += 'Valor: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                    roleTooltip += '</div>'
                    roleTooltip += '</div>'

                    resFpagto.push(
                        [item.descricao, item.valor, `stroke-color: #fff; stroke-opacity: 0.8; stroke-width: 1; fill-color: ${colors[0]}; fill-opacity: 0.6`, roleTooltip],
                    )
                    if (position > 9) {
                        position = 0
                    } else {
                        position++
                    }

                    return true
                })
            } else {
                setTitleFpagto("")
                resFpagto.push(["X", "", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                resFpagto.push(
                    [
                        "", 0, "stroke-color: #fff; stroke-opacity: 1; stroke-width: 2; fill-color: #fff; fill-opacity: 1", ""
                    ]
                )
                //setTicksChartBar([0, 500, 1000, 1500, 2000, 2500])
            }

            setResVendaFpagto(resFpagto)
            setTop10ProdutosList(dadosDashboard.resTop10Produtos)

            // CONTAS A PAGAR ----------------------------------------------------------------------------------------------
            const dadosCtaPagar = dadosDashboard.ctaPagarList.DadosCtaPagar.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupPagarList(dadosCtaPagar)
            calcQtdPagesDupPagar(dadosDashboard.ctaPagarList.total)
            setCurrentPageDupPagar(1)


            // CONTAS A RECEBER ----------------------------------------------------------------------------------------------
            const dadosCtaReceber = dadosDashboard.ctaReceberList.DadosCtaReceber.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupReceberList(dadosCtaReceber)
            calcQtdPagesDupRec(dadosDashboard.ctaReceberList.total)
            setCurrentPageDupReceber(1)

            // LANÇAMENTO DE CARTAO ----------------------------------------------------------------------------------------------
            const dadosLanctoCartao = dadosDashboard.lanctoCartaoList.DadosLanctoCartao.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.dt_vencimento).getTime();
                const dataB = new Date(b.dt_vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setLanctoCartaoList(dadosLanctoCartao)
            calcQtdPagesLanctoCartao(dadosDashboard.lanctoCartaoList.total)
            setCurrentPageLanctoCartao(1)



            // SALDO DAS CONTAS ----------------------------------------------------------------------------------------------
            const dadosSaldo = dadosDashboard.saldoConta.DadosSaldo.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setSaldoContasList(dadosSaldo)
            calcQtdPagesSaldoContas(dadosDashboard.saldoConta.total)
            setCurrentPageSaldoContas(1)


            // ESTOQUE PRODUTOS ----------------------------------------------------------------------------------------------
            const dadosEstoque = dadosDashboard.produtoEstoque.DadosEstoque.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setEstoqueList(dadosEstoque)
            calcQtdPagesEstoque(dadosDashboard.produtoEstoque.total)
            setCurrentPageEstoque(1)

            /*
            const respSaldo = await HomeService.SaldoContas(currentPageSaldoContas)
            if (respSaldo.DadosSaldo.length > 0) {
                calcQtdPagesSaldoContas(respSaldo.total)
                setSaldoContasList(respSaldo.DadosSaldo)
            }
    
            const respDupRec = await HomeService.RelCtaReceber(dateISemana, dateFSemana, currentPageSaldoContas)
            if (respDupRec.DadosCtaReceber.length > 0) {
                calcQtdPagesDupRec(respDupRec.total)
                setDupReceberList(respDupRec.DadosCtaReceber)
            }
    
            const respEstoque = await HomeService.ProdutoReposicao(currentPageEstoque)
            if (respEstoque.DadosEstoque.length > 0) {
                calcQtdPagesEstoque(respEstoque.total)
                setEstoqueList(respEstoque.DadosEstoque)
            }
            */

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)

        }

    }

    const getDadosDashboardMes = async () => {

        setLoading(true)
        setFilter_Type_Dashboard('Mes')

        try {

            const dadosDashboard = await HomeService.GetData(dateIMes, dateFMes)

            setDataInicio(dateIMes)
            setDataFim(dateFMes)

            setReceita(dadosDashboard.receita)
            setDespesa(dadosDashboard.despesa)
            setVenda(dadosDashboard.venda)
            setTicketMedioVenda(dadosDashboard.ticketMedioVenda)
            setVlCheDeposito(dadosDashboard.valorChequeDeposito)

            let res = []
            res.push(["X", "Vendas", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])

            dadosDashboard.resVendaMensal.map((item: ResVendaMensal) => {
                let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'

                roleTooltip += '<div>'
                roleTooltip += '<strong>' + item.mes + '</strong>'
                roleTooltip += '</div>'
                roleTooltip += '<div style="margin: 5px 0">'
                roleTooltip += 'Venda: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                roleTooltip += '</div>'
                roleTooltip += '</div>'

                res.push([
                    item.mes, item.valor, 'fill-color: #FFF; fill-opacity: 0.1; stroke-color: #FFF; stroke-opacity: 1; stroke-width: 5',
                    roleTooltip
                ]);
                return true
            })

            setResVendaMensal(res)

            let resFpagto = []

            if (dadosDashboard.resVendaFpagto.length > 0) {

                //setTicksChartBar([])
                resFpagto.push(["X", "Forma de Pagamento", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                let position = 0
                dadosDashboard.resVendaFpagto.map((item: ResVendaFpagto) => {
                    let roleTooltip = '<div style="min-width: 150px; padding: 10px 15px">'
                    roleTooltip += '<div>'
                    roleTooltip += '<strong>' + item.descricao + '</strong>'
                    roleTooltip += '</div>'
                    roleTooltip += '<div style="margin: 5px 0">'
                    roleTooltip += 'Valor: ' + Funcoes.numberFormat(item.valor, 'currency', 2, 2)
                    roleTooltip += '</div>'
                    roleTooltip += '</div>'

                    resFpagto.push(
                        [item.descricao, item.valor, `stroke-color: #fff; stroke-opacity: 0.8; stroke-width: 1; fill-color: ${colors[0]}; fill-opacity: 0.6`, roleTooltip],
                    )
                    if (position > 9) {
                        position = 0
                    } else {
                        position++
                    }

                    return true
                })
            } else {
                setTitleFpagto("")
                resFpagto.push(["X", "", { role: 'style' }, { role: 'tooltip', 'p': { 'html': true } }])
                resFpagto.push(
                    [
                        "", 0, "stroke-color: #fff; stroke-opacity: 1; stroke-width: 2; fill-color: #fff; fill-opacity: 1", ""
                    ]
                )
                //setTicksChartBar([0, 500, 1000, 1500, 2000, 2500])
            }

            setResVendaFpagto(resFpagto)
            setTop10ProdutosList(dadosDashboard.resTop10Produtos)


            // CONTAS A PAGAR ----------------------------------------------------------------------------------------------
            const dadosCtaPagar = dadosDashboard.ctaPagarList.DadosCtaPagar.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupPagarList(dadosCtaPagar)
            calcQtdPagesDupPagar(dadosDashboard.ctaPagarList.total)
            setCurrentPageDupPagar(1)


            // CONTAS A RECEBER ----------------------------------------------------------------------------------------------
            const dadosCtaReceber = dadosDashboard.ctaReceberList.DadosCtaReceber.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.vencimento).getTime();
                const dataB = new Date(b.vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setDupReceberList(dadosCtaReceber)
            calcQtdPagesDupRec(dadosDashboard.ctaReceberList.total)
            setCurrentPageDupReceber(1)


            // LANÇAMENTO DE CARTAO ----------------------------------------------------------------------------------------------
            const dadosLanctoCartao = dadosDashboard.lanctoCartaoList.DadosLanctoCartao.sort((a, b) => {
                // Converte as datas em timestamps para comparar
                const dataA = new Date(a.dt_vencimento).getTime();
                const dataB = new Date(b.dt_vencimento).getTime();
                return dataA - dataB; // Ordem crescente
            })

            setLanctoCartaoList(dadosLanctoCartao)
            calcQtdPagesLanctoCartao(dadosDashboard.lanctoCartaoList.total)
            setCurrentPageLanctoCartao(1)


            // SALDO DAS CONTAS ----------------------------------------------------------------------------------------------
            const dadosSaldo = dadosDashboard.saldoConta.DadosSaldo.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setSaldoContasList(dadosSaldo)
            calcQtdPagesSaldoContas(dadosDashboard.saldoConta.total)
            setCurrentPageSaldoContas(1)


            // ESTOQUE PRODUTOS ----------------------------------------------------------------------------------------------
            const dadosEstoque = dadosDashboard.produtoEstoque.DadosEstoque.sort((a, b) => {
                return a.descricao.localeCompare(b.descricao)
            })

            setEstoqueList(dadosEstoque)
            calcQtdPagesEstoque(dadosDashboard.produtoEstoque.total)
            setCurrentPageEstoque(1)

            /*
            const respSaldo = await HomeService.SaldoContas(currentPageSaldoContas)
            if (respSaldo.DadosSaldo.length > 0) {
                calcQtdPagesSaldoContas(respSaldo.total)
                setSaldoContasList(respSaldo.DadosSaldo)
            }
    
            const respDupRec = await HomeService.RelCtaReceber(dateIMes, dateFMes, currentPageSaldoContas)
            if (respDupRec.DadosCtaReceber.length > 0) {
                calcQtdPagesDupRec(respDupRec.total)
                setDupReceberList(respDupRec.DadosCtaReceber)
            }
    
            const respEstoque = await HomeService.ProdutoReposicao(currentPageEstoque)
            if (respEstoque.DadosEstoque.length > 0) {
                calcQtdPagesEstoque(respEstoque.total)
                setEstoqueList(respEstoque.DadosEstoque)
            }
            */

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)

        }
    }

    // ----------------------------------------- Duplicatas a pagar ---------------------------------------------------------------------------
    const calcQtdPagesDupPagar = (qtdItens: number) => {

        let qtd = 1; // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / 100);

        const newPages = [];
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1);
        }

        setPagesDupPagar(newPages);
    }

    const handleFilterItensPageDupPagar = async (page: number) => {

        setLoadingDupPagarList(true)

        try {

            const respDupPagar = await HomeService.RelCtaPagar(dataInicio, dataFim, page) // isso aqui precisa ser mudado para o contas a pagar
            setCurrentPageDupPagar(page)

            if (respDupPagar.DadosCtaPagar.length > 0) {

                const dadosCtaPagar = respDupPagar.DadosCtaPagar.sort((a, b) => {
                    return new Date(a.vencimento).getTime() - new Date(b.vencimento).getTime();
                })

                setDupPagarList(dadosCtaPagar)
            }

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoadingDupPagarList(false)
                clearTimeout(timer)
            }, 1500)

        }

    }

    const getPageNumbersDupPagar = () => {
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPageDupPagar - Math.floor(maxVisiblePages / 2));
        let end = Math.min(pagesDupPagar.length, start + maxVisiblePages - 1);

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }


    // ----------------------------------------- Duplicatas a receber ---------------------------------------------------------------------------
    const calcQtdPagesDupRec = (qtdItens: number) => {

        let qtd = 1; // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / 100);

        const newPages = [];
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1);
        }

        setPagesDupReceber(newPages);
    }

    const handleFilterItensPageDupRec = async (page: number) => {

        setLoadingDupReceberList(true)

        try {

            const respDupRec = await HomeService.RelCtaReceber(dataInicio, dataFim, page)
            setCurrentPageDupReceber(page)

            if (respDupRec.DadosCtaReceber.length > 0) {

                const dadosCtaPagar = respDupRec.DadosCtaReceber.sort((a, b) => {
                    return new Date(a.vencimento).getTime() - new Date(b.vencimento).getTime();
                })

                setDupReceberList(dadosCtaPagar)
            }

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoadingDupReceberList(false)
                clearTimeout(timer)
            }, 1500)

        }

    }

    const getPageNumbersDupRec = () => {
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPageDupReceber - Math.floor(maxVisiblePages / 2));
        let end = Math.min(pagesDupReceber.length, start + maxVisiblePages - 1);

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }


    // -----------------------------------------  LANÇAMENTO DE CARTÃO ---------------------------------------------------------------------------
    const calcQtdPagesLanctoCartao = (qtdItens: number) => {

        let qtd = 1; // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / 100);

        const newPages = [];
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1);
        }

        setPagesLanctoCartao(newPages);
    }

    const handleFilterItensPageLanctoCartao = async (page: number) => {

        setLoadingLanctoCartaoList(true)

        try {

            const respLanctoCartao = await HomeService.RelLanctoCartao(dataInicio, dataFim, page)
            setCurrentPageLanctoCartao(page)

            if (respLanctoCartao.DadosLanctoCartao.length > 0) {

                const dadosLanctoCartao = respLanctoCartao.DadosLanctoCartao.sort((a, b) => {
                    return new Date(a.dt_vencimento).getTime() - new Date(b.dt_vencimento).getTime();
                })

                setLanctoCartaoList(dadosLanctoCartao)
            }

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoadingLanctoCartaoList(false)
                clearTimeout(timer)
            }, 1500)

        }

    }

    const getPageNumbersLanctoCartao = () => {
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPageLanctoCartao - Math.floor(maxVisiblePages / 2));
        let end = Math.min(pagesLanctoCartao.length, start + maxVisiblePages - 1);

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }


    // ----------------------------------------- SALDO DAS CONTAS ---------------------------------------------------------------------------
    const calcQtdPagesSaldoContas = (qtdItens: number) => {

        let qtd = 1; // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / 100);


        const newPages = [];
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1);
        }

        setPagesSaldoContas(newPages);
    }

    const handleFilterItensPageSaldoContas = async (page: number) => {

        setLoadingSaldoContasList(true)

        try {

            const respSaldo = await HomeService.SaldoContas(page)
            setCurrentPageSaldoContas(page)

            if (respSaldo.DadosSaldo.length > 0) {

                const dadosSaldo = respSaldo.DadosSaldo.sort((a, b) => {
                    return a.descricao.localeCompare(b.descricao)
                })

                setSaldoContasList(dadosSaldo)
            }

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoadingSaldoContasList(false)
                clearTimeout(timer)
            }, 1500)

        }

    }

    const getPageNumbersSaldoContas = () => {
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPageSaldoContas - Math.floor(maxVisiblePages / 2));
        let end = Math.min(pagesSaldoContas.length, start + maxVisiblePages - 1);

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }


    // ---------------------------------------- PRODUTOS COM POUCO ESTOQUE -------------------------------------------------------------------
    const calcQtdPagesEstoque = (qtdItens: number) => {

        let qtd = 1; // Começa com uma página por padrão

        qtd = Math.ceil(qtdItens / 100);

        const newPages = [];
        for (let i = 0; i < qtd; i++) {
            newPages.push(i + 1);
        }

        setPagesEstoque(newPages);
    }

    const handleFilterItensPageEstoque = async (page: number) => {

        setLoadingEstoqueList(true)

        try {

            const respEstoque = await HomeService.ProdutoReposicao(page)

            setCurrentPageEstoque(page)

            if (respEstoque.DadosEstoque.length > 0) {

                const dadosEstoque = respEstoque.DadosEstoque.sort((a, b) => {
                    return a.descricao.localeCompare(b.descricao)
                })

                setEstoqueList(dadosEstoque)
            }

        } catch (error) {

        } finally {

            const timer = setTimeout(() => {
                setLoadingEstoqueList(false)
                clearTimeout(timer)
            }, 1500)

        }
    }

    const getPageNumbersEstoque = () => {
        const maxVisiblePages = 5;
        let start = Math.max(1, currentPageEstoque - Math.floor(maxVisiblePages / 2));
        let end = Math.min(pagesEstoque.length, start + maxVisiblePages - 1);

        if (end - start + 1 < maxVisiblePages) {
            start = Math.max(1, end - maxVisiblePages + 1);
        }

        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }


    // -------------------------------------------- Scale Receita --------------------------------------------------------
    const addHoverEffectdivReceita = () => {
        const divReceita = document.getElementById("divSubReceita");
        divReceita?.classList.add("scale-105", "ease-in-out");
    }

    const removeHoverEffectdivReceita = () => {
        const divReceita = document.getElementById("divSubReceita");
        divReceita?.classList.remove("scale-105", "ease-in-out");
    }


    // -------------------------------------------- Scale Despesa --------------------------------------------------------
    const addHoverEffectdivDespesa = () => {
        const divDespesa = document.getElementById("divSubDespesa");
        divDespesa?.classList.add("scale-105", "ease-in-out");
    }

    const removeHoverEffectdivDespesa = () => {
        const divDespesa = document.getElementById("divSubDespesa");
        divDespesa?.classList.remove("scale-105", "ease-in-out");
    }


    // -------------------------------------------- Scale Vendas --------------------------------------------------------
    const addHoverEffectdivVendas = () => {
        const divVendas = document.getElementById("divSubVendas");
        divVendas?.classList.add("scale-105", "ease-in-out");
    }

    const removeHoverEffectdivVendas = () => {
        const divVendas = document.getElementById("divSubVendas");
        divVendas?.classList.remove("scale-105", "ease-in-out");
    }


    // -------------------------------------------- Scale Ticket Medio ---------------------------------------------------
    const addHoverEffectdivTicketMedioVendas = () => {
        const divVendas = document.getElementById("divSubTicketMedioVendas");
        divVendas?.classList.add("scale-105", "ease-in-out");
    }

    const removeHoverEffectdivTicketMedioVendas = () => {
        const divVendas = document.getElementById("divSubTicketMedioVendas");
        divVendas?.classList.remove("scale-105", "ease-in-out");
    }


    // -------------------------------------------- Scale Cheque --------------------------------------------------------
    const addHoverEffectdivCheques = () => {
        const divCheques = document.getElementById("divSubCheques");
        divCheques?.classList.add("scale-105", "ease-in-out");
    }

    const removeHoverEffectdivCheques = () => {
        const divCheques = document.getElementById("divSubCheques");
        divCheques?.classList.remove("scale-105", "ease-in-out");
    }


    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])


    // ---------------------------------------------------------------------------------- SEM USO ---------------------------------------------------------------------------------------
    const handleReceitaHojeClick = async () => {
        /*
        setShowMenuReceita(false);
        setLoadingReceita(true)
        const dadosDashboard = await HomeService.GetData(dateIDia, dateFDia)
        setReceita(dadosDashboard.receita)
        setLoadingReceita(false)
        */
    }

    const handleReceitaSemanaClick = async () => {
        /*
        setShowMenuReceita(false);
        setLoadingReceita(true)
        const dadosDashboard = await HomeService.GetData(dateISemana, dateFSemana)
        setReceita(dadosDashboard.receita)
        setLoadingReceita(false)
        */
    }

    const handleReceitaMesClick = async () => {
        /*
        setShowMenuReceita(false)
        setLoadingReceita(true)
        const dadosDashboard = await HomeService.GetData(dateIMes, dateFMes)
        setReceita(dadosDashboard.receita)
        setLoadingReceita(false)
        */
    }

    const handleDocEmitidoHojeClick = () => {
        //setShowMenuDocEmitido(false);
    }

    const handleDocEmitidoSemanaClick = () => {
        //setShowMenuDocEmitido(false);
    }

    const handleDocEmitidoMesClick = () => {
        //setShowMenuDocEmitido(false);
    }

    const handleDupPagarHojeClick = async () => {
        /*
        setLoadingCtaPagar(true)
        const dadosDashboard = await HomeService.GetData(dateIDia, dateFDia)
        setDupPagarList(dadosDashboard.ctaPagarList)
        setshowMenuDupPagar(false);
        setLoadingCtaPagar(false)
        */
    }

    const handleDupPagarSemanaClick = async () => {
        /*
        setLoadingCtaPagar(true)
        const dadosDashboard = await HomeService.GetData(dateISemana, dateFSemana)
        setDupPagarList(dadosDashboard.ctaPagarList)
        setshowMenuDupPagar(false);
        setLoadingCtaPagar(false)
        */
    }

    const handleDupPagarMesClick = async () => {
        /*
        setLoadingCtaPagar(true)
        const dadosDashboard = await HomeService.GetData(dateIMes, dateFMes)
        setDupPagarList(dadosDashboard.ctaPagarList)
        setshowMenuDupPagar(false);
        setLoadingCtaPagar(false)
        */
    }

    const handleVendaFpagtoHojeClick = () => {
        //setshowMenuVendaFpagto(false);
    }

    const handleVendaFpagtoSemanaClick = () => {
        //setshowMenuVendaFpagto(false);
    }

    const handleVendaFpagtoMesClick = () => {
        //setshowMenuVendaFpagto(false);
    }

    const handleTop10ProdsHojeClick = () => {
        //setshowMenuTop10Prods(false);
    }

    const handleTop10ProdsSemanaClick = () => {
        //setshowMenuTop10Prods(false);
    }

    const handleTop10ProdsMesClick = () => {
        //setshowMenuTop10Prods(false);
    }

    const handleResVendaMensalHojeClick = () => {
        //setshowMenuResVendaMensal(false);
    }

    const handleResVendaMensalSemanaClick = () => {
        //setshowMenuResVendaMensal(false);
    }

    const handleResVendaMensalMesClick = () => {
        //setshowMenuResVendaMensal(false);
    }

    const handleChequeHojeClick = () => {
        //setshowMenuCheque(false);
    }

    const handleChequeSemanaClick = () => {
        //setshowMenuCheque(false);
    }

    const handleChequeMesClick = () => {
        //setshowMenuCheque(false);
    }

    const handleVendaHojeClick = () => {
        //setshowMenuVenda(false);
    }

    const handleVendaSemanaClick = () => {
        //setshowMenuVenda(false);
    }

    const handleVendaMesClick = () => {
        //setshowMenuVenda(false);
    }

    const handleDespesaHojeClick = () => {
        //setshowMenuDespesa(false);
    }

    const handleDespesaSemanaClick = () => {
        //setshowMenuDespesa(false);
    }

    const handleDespesaMesClick = () => {
        //setshowMenuDespesa(false);
    }

    const handleTickeClienteHojeClick = () => {
        //setShowMenuTicketMedioCliente(false);
    }

    const handleTickeClienteSemanaClick = () => {
        //setShowMenuTicketMedioCliente(false);
    }

    const handleTickeClienteMesClick = () => {
        //setShowMenuTicketMedioCliente(false);
    }

    const toggleMenuDocEmitidoClick = () => {
        //setShowMenuDocEmitido(!showMenuDocEmitido);
    }

    const toggleMenuTicketMedioClienteClick = () => {
        //setShowMenuTicketMedioCliente(!showMenuTicketMedioCliente);
    }

    const toggleMenuReceitaClick = () => {
        //setShowMenuReceita(!showMenuReceita);
    }

    const toggleMenuDespesaClick = () => {
        //setshowMenuDespesa(!showMenuDespesa);
    }

    const toggleMenuVendasClick = () => {
        //setshowMenuVenda(!showMenuVenda);
    }

    const toggleMenuChequesClick = () => {
        //setshowMenuCheque(!showMenuCheques);
    }

    const toggleMenuResVendaMensalClick = () => {
        //setshowMenuResVendaMensal(!showMenuResVendaMensal);
    }

    const toggleshowMenuTop10Prods = () => {
        //setshowMenuTop10Prods(!showMenuTop10Prods);
    }

    const toggleMenuVendaFpagto = () => {
        //setshowMenuVendaFpagto(!showMenuVendaFpagto);
    }

    const toggleshowMenuDupPagar = () => {
        //setshowMenuDupPagar(!showMenuDupPagar);
    }

    const toggleshowMenuDupReceber = () => {
        //setshowMenuReceber(!showMenuReceber);
    }

    return (
        <Template isLoading={loading} >

            <div className={`w-full h-auto flex`}>

                <div id="div-body" className={`w-full h-[100%] lg:ml-[230px] mt-[55px] ml-30 mr-2 mb-2 pb-[20px] pt-[10px] transition-all duration-500 pl-4 lg:pl-8 pr-2`}>

                    <div className={`w-full h-full grid gap-2 grid-cols-10 mt-3`}>

                        <div className={`relative col-span-10`}>
                            <span className={`font-semibold font-sans text-slate-600 dark:text-slate-200`}>Filtrar dados por: </span>
                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-600 w-[100%] mt-2`} />
                        </div>

                        <div className={`relative col-span-3 md:col-span-1`}>

                            <button tabIndex={-1} className={`${classbtColunasAzul} ${filter_type_dashboard === 'Dia' ? 'bg-[#2980b9] dark:bg-[#D2C85F]' : ''} h-9`} onClick={getDadosDashboardDia} >
                                <span className={`w-full h-full flex justify-center items-center ${filter_type_dashboard === 'Dia' ? 'text-white dark:text-black' : ''}`}>Dia</span>
                            </button>

                        </div>

                        <div className={`relative col-span-3 md:col-span-1`}>

                            <button tabIndex={-1} className={`${classbtColunasAzul}  ${filter_type_dashboard === 'Semana' ? 'bg-[#2980b9] dark:bg-[#D2C85F]' : ''} h-9`} onClick={getDadosDashboardSemana} >
                                <span className={`w-full h-full flex justify-center items-center ${filter_type_dashboard === 'Semana' ? 'text-white dark:text-black' : ''}`}>Semana</span>
                            </button>

                        </div>

                        <div className={`relative col-span-3 md:col-span-1`}>

                            <button tabIndex={-1} className={`${classbtColunasAzul} ${filter_type_dashboard === 'Mes' ? 'bg-[#2980b9] dark:bg-[#D2C85F]' : ''} h-9 `} onClick={getDadosDashboardMes} >
                                <span className={`w-full h-full flex justify-center items-center ${filter_type_dashboard === 'Mes' ? 'text-white dark:text-black' : ''}`}>Mês</span>
                            </button>

                        </div>



                    </div>

                    <div className={`w-full h-full grid gap-2 grid-cols-12 2xl:grid-cols-10 mt-3`}>

                        <div id='divReceita' className={`relative flex flex-col col-span-12 md:col-span-6 2xl:col-span-2 bg-slate-200 dark:bg-slate-700 transition-all duration-500`} onMouseOver={addHoverEffectdivReceita} onMouseOut={removeHoverEffectdivReceita}  >

                            <div className={`static w-full h-full flex flex-col mt-3 px-3 py-1 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md transition-bg duration-300 cursor-default`}>

                                <div className={`w-full h-[70px] flex justify-end`}>

                                    <div id='divSubReceita' className={`absolute top-0 left-4 w-14 h-14 flex justify-center items-center bg-[#55AE59] shadow-sm shadow-slate-400 dark:shadow-slate-700 rounded-md transform transition-transform duration-150`}>
                                        <img src={iconReceita} alt="" style={{ width: '30px', height: '30px', filter: 'invert(100%)' }} />
                                    </div>

                                    <span className={`w-full flex justify-end sm:text-base md:text-lg text-slate-400 dark:text-white`}>Receita</span>

                                </div>

                                <hr className={`border-0 h-px bg-gradient-to-r from-slate-100 via-slate-300 to-slate-100 dark:from-slate-700 dark:via-slate-800 dark:to-slate-700 m-1`} />

                                <div className={`w-full h-[40px] flex items-center justify-center flex-grow-1`}>
                                    <span className={`text-slate-400 dark:text-white text-2xl`}>{Funcoes.numberFormat(receita, 'currency', 2, 2)}</span>
                                </div>

                            </div>

                        </div>

                        <div id='divDespesa' className={`relative flex flex-col col-span-12 md:col-span-6 2xl:col-span-2 bg-slate-200 dark:bg-slate-700 transition-all duration-500`} onMouseOver={addHoverEffectdivDespesa} onMouseOut={removeHoverEffectdivDespesa}>

                            <div className={`static w-full h-full flex flex-col mt-3 px-3 py-1 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md transition-bg duration-300 cursor-default`}>

                                <div className={`w-full h-[70px] flex justify-end`}>

                                    <div id='divSubDespesa' className={`absolute top-0 left-4 w-14 h-14 flex justify-center items-center bg-red-500 shadow-sm shadow-slate-400 dark:shadow-slate-700 rounded-md transform transition-transform duration-150`}>
                                        <img src={iconDespesa} alt="" style={{ width: '35px', height: '35px', filter: 'invert(100%)' }} />
                                    </div>

                                    <span className={`w-full flex justify-end ml-2 p-1 sm:text-base md:text-lg text-slate-400 dark:text-white`}> Despesa</span>

                                </div>

                                <hr className={`border-0 h-px bg-gradient-to-r from-slate-100 via-slate-300 to-slate-100 dark:from-slate-700 dark:via-slate-800 dark:to-slate-700 m-1`} />

                                <div className={`w-full h-[40px] flex items-center justify-center flex-grow-1`}>
                                    <span className={`text-slate-400 dark:text-white text-2xl`}>{Funcoes.numberFormat(despesa, 'currency', 2, 2)}</span>
                                </div>

                            </div>

                        </div>

                        <div id='divVendas' className={`relative flex flex-col col-span-12 md:col-span-6 xl:col-span-4 2xl:col-span-2 bg-slate-200 dark:bg-slate-700 transition-all duration-500`} onMouseOver={addHoverEffectdivVendas} onMouseOut={removeHoverEffectdivVendas}>

                            <div className={`static w-full h-full flex flex-col mt-3 px-3 py-1 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md transition-bg duration-300 cursor-default`}>

                                <div className={`w-full h-[70px] flex justify-end`}>

                                    <div id='divSubVendas' className={`absolute top-0 left-4 w-14 h-14 flex justify-center items-center bg-blue-500 shadow-sm shadow-slate-400 dark:shadow-slate-700 rounded-md transform transition-transform duration-150`}>
                                        <BsFillCartCheckFill size={"30px"} className={`text-white mt-1`} />
                                    </div>

                                    <span className={`w-full flex justify-end ml-2 p-1 sm:text-base md:text-lg text-slate-400 dark:text-white`}> Vendas</span>

                                </div>

                                <hr className={`border-0 h-px bg-gradient-to-r from-slate-100 via-slate-300 to-slate-100 dark:from-slate-700 dark:via-slate-800 dark:to-slate-700 m-1`} />

                                <div className={`w-full h-[40px] flex items-center justify-center flex-grow-1`}>
                                    <span className={`text-slate-400 dark:text-white text-2xl`}>{Funcoes.numberFormat(venda, 'currency', 2, 2)}</span>
                                </div>

                            </div>

                        </div>

                        <div id='divTicketMedioVendas' className={`relative flex flex-col col-span-12 md:col-span-6 xl:col-span-4 2xl:col-span-2 bg-slate-200 dark:bg-slate-700 transition-all duration-500`} onMouseOver={addHoverEffectdivTicketMedioVendas} onMouseOut={removeHoverEffectdivTicketMedioVendas}>

                            <div className={`static w-full h-full flex flex-col mt-3 px-3 py-1 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md transition-bg duration-300 cursor-default`}>

                                <div className={`w-full h-[70px] flex justify-end`}>

                                    <div id='divSubTicketMedioVendas' className={`absolute top-0 left-4 w-14 h-14 flex justify-center items-center bg-blue-500 shadow-sm shadow-slate-400 dark:shadow-slate-700 rounded-md transform transition-transform duration-150`}>
                                        <IoTicketSharp size={"30px"} className={`text-white mt-1`} />
                                    </div>

                                    <span className={`w-full flex justify-end ml-2 p-1 sm:text-base md:text-lg text-slate-400 dark:text-white`}> Tícket médio venda</span>

                                </div>

                                <hr className={`border-0 h-px bg-gradient-to-r from-slate-100 via-slate-300 to-slate-100 dark:from-slate-700 dark:via-slate-800 dark:to-slate-700 m-1`} />

                                <div className={`w-full h-[40px] flex items-center justify-center flex-grow-1`}>
                                    <span className={`text-slate-400 dark:text-white text-2xl`}>{Funcoes.numberFormat(ticketMedioVenda, 'currency', 2, 2)}</span>
                                </div>

                            </div>

                        </div>

                        <div id='divCheques' className={`relative flex flex-col col-span-12 xl:col-span-4 2xl:col-span-2 bg-slate-200 dark:bg-slate-700 transition-all duration-500`} onMouseOver={addHoverEffectdivCheques} onMouseOut={removeHoverEffectdivCheques}>

                            <div className={`static w-full h-full flex flex-col mt-3 px-3 py-1 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md transition-bg duration-300 cursor-default`}>

                                <div className={`w-full h-[70px] flex justify-end`}>

                                    <div id='divSubCheques' className={`absolute top-0 left-4 w-14 h-14 flex justify-center items-center bg-cyan-500 shadow-sm shadow-slate-400 dark:shadow-slate-700 rounded-md transform transition-transform duration-150`}>
                                        <img src={iconChequeDeposito} alt="" style={{ width: '35px', height: '35px', filter: 'invert(100%)' }} />
                                    </div>

                                    <span className={`w-full flex justify-end ml-2 p-1 sm:text-base md:text-lg text-slate-400 dark:text-white`}> Cheques p/ depósito</span>

                                </div>

                                <hr className={`border-0 h-px bg-gradient-to-r from-slate-100 via-slate-300 to-slate-100 dark:from-slate-700 dark:via-slate-800 dark:to-slate-700 m-1`} />

                                <div className={`w-full h-[40px] flex items-center justify-center flex-grow-1`}>
                                    <span className={`text-slate-400 dark:text-white text-2xl`}>{Funcoes.numberFormat(vlCheDeposito, 'currency', 2, 2)}</span>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full h-full grid gap-2 grid-cols-10 mt-3`}>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-[300px] flex flex-col`}>

                                <div className={`static w-full h-full flex flex-col rounded-md transition-bg duration-300`}>
                                    <div className={`absolute -top-6 right-4 left-4 h-full bg-[#60A5FA] border-2 border-[#60A5FA] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg`}>
                                        <Chart
                                            chartType="LineChart"
                                            data={resVendaMensal}
                                            width="100%"
                                            height="100%"
                                            options={optionsChart}
                                        />
                                    </div>
                                </div>

                                <div className={`absolute -bottom-16 w-full h-[80px] flex`}>

                                    <div className={`w-full flex flex-col`}>
                                        <span className={`w-full ml-4 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-black dark:text-white`}>Resumo de Venda Mensal</span>
                                        <span className={`w-full ml-4 text-sm text-gray-400 dark:text-gray-200`}>Resumo de Vendas de cada mês.</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-[300px] flex flex-col`}>

                                <div className={`static w-full h-full flex flex-col rounded-md transition-bg duration-300`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-full bg-[#343439] border-2 border-[#343439] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg`}>

                                        <Chart
                                            chartType="ColumnChart"
                                            data={resVendaFpagto}
                                            width="100%"
                                            height="100%"
                                            options={optionsBar}
                                        />

                                    </div>

                                </div>

                                <div className={`absolute -bottom-16 w-full h-[80px] flex`}>

                                    <div className={`w-full flex flex-col`}>
                                        <span className={`w-full ml-4 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-black dark:text-white`}>Venda por forma de pagamento</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-[#307E3C] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <GiReceiveMoney size={"40px"} className={`text-white`} />
                                        <span className={`ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white w-full flex items-center`}>Duplicatas a Receber</span>

                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-14`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className=''>
                                            <tr key={uuid()} className=''>
                                                <td className={`pl-2 pb-0.5 text-base dark:text-white w-1/4`}>Nome</td>
                                                <td className={`pl-2 pb-0.5 text-base dark:text-white w-1/4`}>Observação</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-1/4`}>Vencimento</td>
                                                <td className={`pr-3 pb-0.5 text-right dark:text-white text-base w-1/4`}>Valor</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[255px] overflow-y-hidden hover:overflow-y-auto scrollbar-thin scrollbar-thumb-[#307E3C] scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>
                                    <table className={`w-full h-auto`}>
                                        <tbody>
                                            {dupReceberList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-l-0 border-r-0 dark:border-gray-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-1/4 dark:text-white`}>{item.nomeFornecedor}</td>
                                                    <td className={`pl-2 text-sm w-1/4 dark:text-white`}>{item.observacao}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.FormatDataPtBr(item.vencimento)}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {loadingDupReceberList &&

                                    <div className={`absolute top-[80px] bottom-0 left-0 right-0 bg-white dark:bg-slate-600 opacity-60 z-20 flex justify-center items-center`}>
                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    </div>
                                }

                                <div className={`w-auto h-auto absolute bottom-2 left-0 right-0`}>
                                    { /* Paginação */}
                                    <div className={`h-14 flex flex-row items-center mx-2 transition-all duration-300`}>
                                        {dupReceberList.length > 0 &&

                                            <>
                                                <button tabIndex={-1} onClick={() => handleFilterItensPageDupRec(currentPageDupReceber - 1)} disabled={currentPageDupReceber === 1}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-l-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowBack className={`text-slate-600 dark:text-slate-300`} />
                                                </button>

                                                {getPageNumbersDupRec().map((pageNumber: any) => {
                                                    return (

                                                        <button tabIndex={-1} onClick={() => handleFilterItensPageDupRec(pageNumber)} key={pageNumber}
                                                            className={`flex items-center justify-center w-9 h-9 border border-slate-100 dark:border-slate-600 ${pageNumber === currentPageDupReceber ? 'bg-slate-300 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700'} transition-all duration-150 hover:underline hover:underline-offset-2 text-white text-sm`}>
                                                            <span className={`text-slate-600 dark:text-white`}>{pageNumber}</span>
                                                        </button>
                                                    )
                                                })}

                                                <button tabIndex={-1} onClick={() => handleFilterItensPageDupRec(currentPageDupReceber + 1)} disabled={currentPageDupReceber >= pagesDupReceber.length}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-r-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowForward className={`text-slate-600 dark:text-slate-300`} />
                                                </button>
                                            </>
                                        }

                                    </div>
                                    { /* Paginação */}
                                </div>

                            </div>
                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-[#E73D39] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <GiPayMoney size={"40px"} className={`text-white`} />
                                        <span className={`ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white w-full`}>Duplicatas a Pagar</span>
                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-14`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className=''>
                                            <tr key={uuid()} className=''>
                                                <td className={`pl-2 pb-0.5 text-base dark:text-white w-1/4`}>Fornecedor</td>
                                                <td className={`pl-2 pb-0.5 text-right dark:text-white text-base w-1/4`}>Duplicata</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-1/4`}>Vencimento</td>
                                                <td className={`pr-3 pb-0.5 text-right dark:text-white text-base w-1/4`}>Valor</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[255px] overflow-y-hidden hover:overflow-y-auto scrollbar-thin scrollbar-thumb-red-400 scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>
                                    <table className={`w-full h-auto`}>
                                        <tbody>
                                            {dupPagarList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-l-0 border-r-0 dark:border-gray-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-1/4 dark:text-white`}>{item.nomeFornecedor}</td>
                                                    <td className={`pl-2 text-right text-sm w-1/4 dark:text-white`}>{item.numDoc}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.FormatDataPtBr(item.vencimento)}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {loadingDupPagarList &&

                                    <div className={`absolute top-[80px] bottom-0 left-0 right-0 bg-white dark:bg-slate-600 opacity-60 z-20 flex justify-center items-center`}>
                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    </div>
                                }

                                <div className={`w-auto h-auto absolute bottom-2 left-0 right-0`}>
                                    { /* Paginação */}
                                    <div className={`h-14 flex flex-row items-center mx-2 transition-all duration-300`}>
                                        {dupPagarList.length > 0 &&

                                            <>
                                                <button tabIndex={-1} onClick={() => handleFilterItensPageDupPagar(currentPageDupPagar - 1)} disabled={currentPageDupPagar === 1}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-l-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowBack className={`text-slate-600 dark:text-slate-300`} />
                                                </button>

                                                {getPageNumbersDupPagar().map((pageNumber: any) => {
                                                    return (

                                                        <button tabIndex={-1} onClick={() => handleFilterItensPageDupPagar(pageNumber)} key={pageNumber}
                                                            className={`flex items-center justify-center w-9 h-9 border border-slate-100 dark:border-slate-600 ${pageNumber === currentPageDupPagar ? 'bg-slate-300 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700'} transition-all duration-150 hover:underline hover:underline-offset-2 text-white text-sm`}>
                                                            <span className={`text-slate-600 dark:text-white`}>{pageNumber}</span>
                                                        </button>
                                                    )
                                                })}

                                                <button tabIndex={-1} onClick={() => handleFilterItensPageDupPagar(currentPageDupPagar + 1)} disabled={currentPageDupPagar >= pagesDupPagar.length}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-r-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowForward className={`text-slate-600 dark:text-slate-300`} />
                                                </button>
                                            </>
                                        }

                                    </div>
                                    { /* Paginação */}
                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-[#748FA1] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <GiCardPlay size={"40px"} className={`text-white`} />
                                        <span className={`ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white w-full`}>Lançamentos de Cartão a baixar</span>
                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-14`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className=''>
                                            <tr key={uuid()} className=''>
                                                <td className={`pl-2 pb-0.5 text-base dark:text-white w-1/4`}>Cliente</td>
                                                <td className={`pl-2 pb-0.5 text-right dark:text-white text-base w-1/4`}>Num. transição</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-1/4`}>Vencimento</td>
                                                <td className={`pr-3 pb-0.5 text-right dark:text-white text-base w-1/4`}>Valor</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[255px] overflow-y-hidden hover:overflow-y-auto scrollbar-thin scrollbar-thumb-red-400 scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>
                                    <table className={`w-full h-auto`}>
                                        <tbody>
                                            {lanctoCartaoList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-l-0 border-r-0 dark:border-gray-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-1/4 dark:text-white`}>{item.name_cliente}</td>
                                                    <td className={`pl-2 text-right text-sm w-1/4 dark:text-white`}>{item.numero_transacao}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.FormatDataPtBr(item.dt_vencimento)}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/4 dark:text-white`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {loadingLanctoCartaoList &&

                                    <div className={`absolute top-[80px] bottom-0 left-0 right-0 bg-white dark:bg-slate-600 opacity-60 z-20 flex justify-center items-center`}>
                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    </div>
                                }

                                <div className={`w-auto h-auto absolute bottom-2 left-0 right-0`}>
                                    { /* Paginação */}
                                    <div className={`h-14 flex flex-row items-center mx-2 transition-all duration-300`}>
                                        {lanctoCartaoList.length > 0 &&

                                            <>
                                                <button tabIndex={-1} onClick={() => handleFilterItensPageLanctoCartao(currentPageLanctoCartao - 1)} disabled={currentPageLanctoCartao === 1}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-l-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowBack className={`text-slate-600 dark:text-slate-300`} />
                                                </button>

                                                {getPageNumbersLanctoCartao().map((pageNumber: any) => {
                                                    return (

                                                        <button tabIndex={-1} onClick={() => handleFilterItensPageLanctoCartao(pageNumber)} key={pageNumber}
                                                            className={`flex items-center justify-center w-9 h-9 border border-slate-100 dark:border-slate-600 ${pageNumber === currentPageLanctoCartao ? 'bg-slate-300 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700'} transition-all duration-150 hover:underline hover:underline-offset-2 text-white text-sm`}>
                                                            <span className={`text-slate-600 dark:text-white`}>{pageNumber}</span>
                                                        </button>
                                                    )
                                                })}

                                                <button tabIndex={-1} onClick={() => handleFilterItensPageLanctoCartao(currentPageLanctoCartao + 1)} disabled={currentPageLanctoCartao >= pagesLanctoCartao.length}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-r-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowForward className={`text-slate-600 dark:text-slate-300`} />
                                                </button>
                                            </>
                                        }

                                    </div>
                                    { /* Paginação */}
                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-[#03AEC3] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <GiPodium size={"40px"} className={`text-white`} />
                                        <span className={`w-full flex items-center ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white`}> Top 10 produtos mais vendidos</span>

                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-16`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className=''>
                                            <tr className=''>
                                                <td className={`pl-2 pb-0.5 text-base  dark:text-white w-1/3`}>Produto</td>
                                                <td className={`pl-2 pb-0.5 text-right dark:text-white text-base w-1/3`}>Qtd. vendida</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-1/3`}>Valor vendido</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[300px] overflow-y-hidden hover:overflow-y-auto scrollbar-thin scrollbar-thumb-cyan-500 scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>

                                    <table className={`w-full h-auto`}>

                                        <tbody>

                                            {top10ProdutosList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-b-0 border-l-0 border-r-0 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-1/3 dark:text-white`}>{item.descricao}</td>
                                                    <td className={`pl-2 text-right text-sm w-1/3 dark:text-white`}>{item.qtd}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/3 dark:text-white`}>{Funcoes.numberFormat(item.vlTot, 'currency', 2, 2)}</td>
                                                </tr>
                                            })}

                                        </tbody>

                                    </table>

                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-indigo-400 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <TbPigMoney size={"40px"} className={`text-white`} />
                                        <span className={`w-full flex items-center ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white`}>Saldo das Contas</span>

                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-14`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className=''>
                                            <tr className=''>
                                                <td className={`pl-2 pb-0.5 text-base  dark:text-white w-[50%]`}>Contas</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-[50%]`}>Saldo (R$)</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[250px] overflow-y-auto scrollbar-thin scrollbar-thumb-indigo-400 scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>

                                    <table className={`w-full h-auto`}>

                                        <tbody>

                                            {saldoContasList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-b-0 border-l-0 border-r-0 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-[50%] dark:text-white`}>{item.descricao}</td>
                                                    <td className={`pr-2 text-right text-sm w-[50%] dark:text-white`}>{Funcoes.numberFormat(item.saldo, 'decimal', 2, 2)}</td>
                                                </tr>
                                            })}

                                        </tbody>

                                    </table>

                                </div>

                                {loadingSaldoContasList &&

                                    <div className={`absolute top-[80px] bottom-0 left-0 right-0 bg-white dark:bg-slate-600 opacity-60 z-20 flex justify-center items-center`}>
                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    </div>
                                }

                                <div className={`w-auto h-auto absolute bottom-2 left-0 right-0`}>
                                    { /* Paginação */}
                                    <div className={`h-14 flex flex-row items-center mx-2 transition-all duration-300`}>
                                        {saldoContasList.length > 0 &&

                                            <>
                                                <button tabIndex={-1} onClick={() => handleFilterItensPageSaldoContas(currentPageSaldoContas - 1)} disabled={currentPageSaldoContas === 1}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-l-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowBack className={`text-slate-600 dark:text-slate-300`} />
                                                </button>

                                                {getPageNumbersSaldoContas().map((pageNumber: any) => {
                                                    return (

                                                        <button tabIndex={-1} onClick={() => handleFilterItensPageSaldoContas(pageNumber)} key={pageNumber}
                                                            className={`flex items-center justify-center w-9 h-9 border border-slate-100 dark:border-slate-600 ${pageNumber === currentPageSaldoContas ? 'bg-slate-300 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700'} transition-all duration-150 hover:underline hover:underline-offset-2 text-white text-sm`}>
                                                            <span className={`text-slate-600 dark:text-white`}>{pageNumber}</span>
                                                        </button>
                                                    )
                                                })}

                                                <button tabIndex={-1} onClick={() => handleFilterItensPageSaldoContas(currentPageSaldoContas + 1)} disabled={currentPageSaldoContas >= pagesSaldoContas.length}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-r-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowForward className={`text-slate-600 dark:text-slate-300`} />
                                                </button>
                                            </>
                                        }

                                    </div>
                                    { /* Paginação */}
                                </div>

                            </div>

                        </div>

                        <div className={`w-full h-[400px] max-h-[400px] flex col-span-10 xl:col-span-5 mt-8 bg-white dark:bg-slate-600 border border-slate-100 dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-lg z-20`}>

                            <div className={`relative w-full h-full flex flex-col`}>

                                <div className={`static`}>

                                    <div className={`absolute -top-6 right-4 left-4 h-[70px] flex items-center justify-end bg-[#333333] shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md p-2`}>

                                        <TbBoxOff size={"40px"} className='text-white' />
                                        <span className={`w-full flex items-center ml-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white`}>Produtos com pouco estoque</span>

                                    </div>

                                </div>

                                <div className={`w-full h-auto mt-14`}>
                                    <table className={`w-full h-auto`}>
                                        <thead className={`rounded-md`}>
                                            <tr className=''>
                                                <td className={`pl-2 pb-0.5 text-base  dark:text-white w-1/3`}>Produto</td>
                                                <td className={`pl-2 pb-0.5 text-right dark:text-white text-base w-1/3`}>estoque mínimo (UN)</td>
                                                <td className={`pr-2 pb-0.5 text-right dark:text-white text-base w-1/3`}>estoque (UN)</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>

                                <div className={`w-full h-[250px] overflow-y-hidden hover:overflow-y-auto scrollbar-thin scrollbar-thumb-[#333333] scrollbar-track-slate-200 dark:scrollbar-track-slate-500`}>
                                    <table className={`w-full h-auto`}>
                                        <tbody>
                                            {estoqueList.map(item => {
                                                return <tr key={uuid()} className={`text-sm h-[50px] border border-b-0 border-l-0 border-r-0 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 bg-opacity-60 transition-all duration-150`}>
                                                    <td className={`pl-2 text-sm w-1/3 dark:text-white`}>{item.descricao}</td>
                                                    <td className={`pl-2 text-right text-sm w-1/3 dark:text-white`}>{Funcoes.numberFormat(item.estoque_minimo, 'decimal')}</td>
                                                    <td className={`pr-2 text-right text-sm w-1/3 dark:text-white`}>{Funcoes.numberFormat(item.estoque_fisico, 'decimal')}</td>
                                                </tr>
                                            })}

                                        </tbody>
                                    </table>
                                </div>

                                {loadingEstoqueList &&

                                    <div className={`absolute top-[80px] bottom-0 left-0 right-0 bg-white dark:bg-slate-600 opacity-60 z-20 flex justify-center items-center`}>
                                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                        </div>
                                    </div>
                                }

                                <div className={`w-auto h-auto absolute bottom-2 left-0 right-0`}>
                                    { /* Paginação */}
                                    <div className={`h-14 flex flex-row items-center mx-2 transition-all duration-300`}>
                                        {estoqueList.length > 0 &&

                                            <>
                                                <button tabIndex={-1} onClick={() => handleFilterItensPageEstoque(currentPageEstoque - 1)} disabled={currentPageEstoque === 1}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-l-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowBack className={`text-slate-600 dark:text-slate-300`} />
                                                </button>

                                                {getPageNumbersEstoque().map((pageNumber: any) => {
                                                    return (

                                                        <button tabIndex={-1} onClick={() => handleFilterItensPageEstoque(pageNumber)} key={pageNumber}
                                                            className={`flex items-center justify-center w-9 h-9 border border-slate-100 dark:border-slate-600 ${pageNumber === currentPageEstoque ? 'bg-slate-300 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-700' : 'bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700'} transition-all duration-150 hover:underline hover:underline-offset-2 text-white text-sm`}>
                                                            <span className={`text-slate-600 dark:text-white`}>{pageNumber}</span>
                                                        </button>
                                                    )
                                                })}

                                                <button tabIndex={-1} onClick={() => handleFilterItensPageEstoque(currentPageEstoque + 1)} disabled={currentPageEstoque >= pagesEstoque.length}
                                                    className={`flex items-center justify-center w-9 h-9 bg-slate-200 hover:bg-slate-300 dark:bg-slate-500 dark:hover:bg-slate-700 rounded-r-md border border-slate-100 dark:border-slate-600`}>
                                                    <IoIosArrowForward className={`text-slate-600 dark:text-slate-300`} />
                                                </button>
                                            </>
                                        }

                                    </div>
                                    { /* Paginação */}
                                </div>

                            </div>

                        </div>

                        { /* Documentos emitidos */}
                        { /*<div className="relative flex flex-col col-span-2 mt-8 sm:mt-[95px] lg:mt-16 sm:col-span-1 w-full h-[155px] rounded-md transition-bg duration-300 cursor-default border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800">

                            <div className='static'>

                                <div className="absolute -top-6 right-4 left-4 flex items-center h-[70px] bg-indigo-400 shadow-md shadow-slate-400 dark:shadow-slate-800 rounded-md">
                                    <div className="flex items-center w-full h-[80px]">
                                        <span className="flex justify-end w-full ml-2">
                                            <span className="w-full ml-2 text-white sm:text-base md:text-lg lg:text-xl"><Icone icon={faFolderClosed} size="sm" cor="#fff" /> Documentos emitidos</span>
                                            <MenuEllipsis id={2} onClick={toggleMenuDocEmitidoClick} showMenu={showMenuDocEmitido} menusList={[
                                                { descricao: 'Hoje', onClick: handleDocEmitidoHojeClick, icon: faCalendar, iconColor: '#4285f4' },
                                                { descricao: 'Semana', onClick: handleDocEmitidoSemanaClick, icon: faCalendarWeek, iconColor: '#4285f4' },
                                                { descricao: 'Mês', onClick: handleDocEmitidoMesClick, icon: faCalendarMinus, iconColor: '#4285f4' },
                                            ]} />
                                        </span>
                                    </div>

                                </div>

                            </div>


                            <div className="flex items-center justify-center w-full h-full pt-12 bg-white rounded-md flex-grow-1 dark:bg-slate-600">
                                <span className="text-2xl text-slate-700 dark:text-white">0</span>
                            </div>
                        </div> */}
                        { /* Documentos emitidos */}

                    </div>

                </div>

            </div>

        </Template>
    )
}